// extracted by mini-css-extract-plugin
module.exports = {"wrap":"DisplayField_wrap__2LhHU","cardWrap":"DisplayField_cardWrap__29D72","dataFlex":"DisplayField_dataFlex__1pgiT"};